import { z } from 'zod';

export const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Use YYYY-MM-DD');
export const id = z.string().min(3).max(64).regex(/^[a-z]{2,6}_[0-9a-z_]+$/, 'Invalid id');
export const currency = z.string().regex(/^[A-Z]{3}$/, 'Use an ISO 4217 code such as INR');
export const countryCode = z.string().regex(/^[A-Z]{2}$/, 'Use an ISO 3166-1 alpha-2 code');
export const moneyMinor = z.number().int().min(0).max(1e13);
export const quantity = z.number().int().positive().max(1e9);
export const basisPoints = z.number().int().min(0).max(10000);
export const nonEmpty = (max = 200) => z.string().trim().min(1).max(max);
export const optionalText = (max = 2000) => z.string().trim().max(max).optional().nullable();
export const email = z.string().trim().toLowerCase().pipe(z.email().max(254));
export const phone = z.string().trim().regex(/^\+?[0-9 ()-]{6,20}$/, 'Invalid phone number');

export const pageQuery = z.object({
  q: z.string().trim().max(100).optional(),
  status: z.string().max(40).optional(),
  cursor: z.string().max(200).optional(),
  limit: z.coerce.number().int().min(1).max(100).default(25),
});
export type PageQuery = z.infer<typeof pageQuery>;

export interface Page<T> {
  items: T[];
  nextCursor: string | null;
}

export interface ApiErrorBody {
  error: { code: string; message: string; details?: unknown; requestId?: string };
}
